<template>
  <div>
    <component :is="selectedSchedulerComponent"
    :selectedSchedulerName="selectedSchedulerInfo.hookscript_name"
    :selectedSchedulerInfo="selectedSchedulerInfo"
    @changeToSelectedSchedulerComponent='changeSelectedSchedulerComponent'
    :isScheduleEditMode="isEditMode"
    v-bind="currentProperties"
    :schedulerClassServiceListForDropDown="schedulerClassServiceList"></component>
  </div>
</template>

<script>
import AddSchedulerInfo from "./schedularWindow.vue"
import ShowSchedulerInfo from "./schedulerWorkspace.vue"
import { mapActions } from "vuex";
  
export default {
  name: "Bins",
  data() {
    return {
      selectedSchedulerComponent: "show-scheduler",
      selectedSchedulerInfo: {},
      isEditMode: false,
      schedulerClassServiceList:[],
    };
  },
  components: {
    "add-scheduler": AddSchedulerInfo,
    "show-scheduler": ShowSchedulerInfo,
  },
  created(){
    this.getSchedulerClassService();
  },

  methods: {
    changeSelectedSchedulerComponent(compName, schedulerInfo={}) { 
      this.selectedSchedulerComponent = compName;
      if(schedulerInfo && Object.keys(schedulerInfo).length>0){
        this.selectedSchedulerInfo = schedulerInfo;
        this.isEditMode = true;
      }else{
        this.selectedSchedulerInfo = {};
        this.isEditMode = false;
      }
    },
    getSchedulerClassService(){
      this.getSchedulerClassServiveFromServer().then((data) =>{
        this.schedulerClassServiceList = data.schedule_services;
      });
    },
    
    ...mapActions("schedulerTask", ["getSchedulerClassServiveFromServer"]),
  },
  computed:{
      currentProperties() {
      if (this.selectedSchedulerComponent === "scheduler-info") {
        return { selectedSchedulerName : this.selectedSchedulerInfo.hookscript_name};
      }
      else{
          return {}
      }
    },
  }
};
</script>

<style scoped>

</style>